import { DataElemType, ServiceTypeModelRobot, ServiceTypeRobot } from "../types/cloudTypes";
import {
	Action,
	ActionType,
	ConditionType,
	DataElemActionEventType,
	DataElemSubType,
	DepthType,
	EndpointType,
	EntryType,
	OperationType,
	ServiceType,
	TOperationSetReport,
	TOperationSetVariable,
} from "../types/ses/sesItemConfigTypes";
import { DaysType, ExceptionType, RobotActionEventType, ServiceDataType } from "../types/ses/sesRobotTypes";
import { ScriptType } from "../types/ses/sesScriptTypes";
import { CorrectionType } from "../types/smcTypes";
import { TSubtypeFreeswitsh, TTypeWeb } from "@/types/ses/sesConnectorTypes";

export type ActionExtended = Action | "chooseAction";
export type ActionTypeExtended = ActionType | "chooseActionType";
export type ServiceTypeExtended = ServiceType | "chooseService";
export type DataElemTypeExtended = DataElemType | "all";
export type ServiceTypeRobotExtended = ServiceTypeRobot | "chooseType";
export type ServiceTypeModelRobotExtended = ServiceTypeModelRobot | "chooseType";
export type ConditionTypeExtended = ConditionType | "chooseType";
export type TOperationSetVariableExtended = TOperationSetVariable | "del";

// список событий робота
export const ROBOT_EVENT_LIST: { event: RobotActionEventType; translation: string }[] = [
	{ event: "start", translation: "selectItem_start" },
	{ event: "hotstart", translation: "selectItem_hotStart" },
	{ event: "loop", translation: "selectItem_returnToStart" },
	{ event: "repeat", translation: "selectItem_repeatRequest" },
	{ event: "silence", translation: "selectItem_silence" },
	{ event: "interrupt", translation: "selectItem_interrupt" },
	{ event: "answer delay", translation: "selectItem_answerDelay" },
	{ event: "not found", translation: "selectItem_notFound" },
	{ event: "no data", translation: "selectItem_noData" },
	{ event: "error", translation: "selectItem_error" },
];

// список исключений робота
export const ROBOT_EXCEPTION_LIST: { exception: ExceptionType; translation: string }[] = [
	{ exception: "silence", translation: "selectItem_silence" },
	{ exception: "not found", translation: "selectItem_nothingFound" },
	{ exception: "no data", translation: "selectItem_noData" },
	{ exception: "unsuccessful run", translation: "selectItem_endpointStartupFailed" },
	{ exception: "answering machine", translation: "selectItem_answeringMachine" },
];

// список сервисных данных робота
export const ROBOT_SERVICE_DATA_LIST: { serviceData: ServiceDataType; translation: string }[] = [
	{ serviceData: "yes", translation: "selectItem_agreement" },
	{ serviceData: "no", translation: "selectItem_negation" },
	{ serviceData: "repeat", translation: "selectItem_repeat" },
	{ serviceData: "interrupt", translation: "selectItem_interrupt" },
	{ serviceData: "answering machine", translation: "selectItem_answeringMachine" },
];

// список действий
export const ACTION_LIST: { action: Action; translation: string }[] = [
	{ action: "say", translation: "selectItem_say" },
	{ action: "confirmation", translation: "selectItem_confirmation" },
	{ action: "sendfile", translation: "selectItem_sendFile" },
	{ action: "setvariable", translation: "selectItem_settingVariable" },
	{ action: "goto", translation: "selectItem_forceMoveToEndpoint" },
	{ action: "setreport", translation: "selectItem_sendingValueToReporting" },
	{ action: "declinedata", translation: "selectItem_declinedata" },
	{ action: "transfer", translation: "selectItem_transferOfDialogue" },
	{ action: "break", translation: "selectItem_breakAction" },
	{ action: "end", translation: "selectItem_endTheDialogue" },
];

// список типов действий
export const ACTION_TYPE_LIST: { actionType: ActionType; translation: string }[] = [
	{ actionType: "linear", translation: "selectItem_linear" },
	{ actionType: "random", translation: "selectItem_randomPhrase" },
	{ actionType: "internal", translation: "selectItem_fromInternalSource" },
	{ actionType: "external", translation: "selectItem_fromExternalSource" },
];

// список сервисов qas
export const SERVICE_TYPE_LIST: { serviceType: ServiceType; translation: string }[] = [
	{ serviceType: "qas-ask", translation: "selectItem_qasDocumentation" },
	{ serviceType: "qas-chat", translation: "selectItem_qasChat" },
];

// список операций установки переменных
export const OPERATION_SET_VARIABLE_LIST: { operation: TOperationSetVariableExtended; translation: string }[] = [
	{ operation: "incr", translation: "+" },
	{ operation: "decr", translation: "-" },
	{ operation: "set", translation: "=" },
	{ operation: "del", translation: "DEL" },
];

// список операций отправки значения в отчетность
export const OPERATION_SET_REPORT_LIST: { operation: TOperationSetReport; translation: string }[] = [{ operation: "set", translation: "=" }];

// список типов ЭД
export const DATA_ELEM_TYPE_LIST: { type: DataElemType; translation: string }[] = [
	{ type: "smc", translation: "selectItem_class" },
	{ type: "see", translation: "selectItem_entity" },
	{ type: "container", translation: "selectItem_container" },
	{ type: "custom", translation: "selectItem_arbitrary" },
];
// словарь типов ЭД
export const DATA_ELEM_TYPE_DICTIONARY = Object.fromEntries(DATA_ELEM_TYPE_LIST.map((item) => [item.type, item.translation]));

// список подтипов smc ЭД
export const DATA_ELEM_SUBTYPE_LIST: { type: DataElemSubType; translation: string }[] = [
	{ type: "class", translation: "selectItem_class" },
	{ type: "group", translation: "selectItem_group" },
];

// список вариантов глубины поиска
export const DEPTH_OPTIONS_LIST: { type: DepthType; translation: string }[] = [
	{ type: "all", translation: "selectItem_throughoutTheDialogue" },
	{ type: "endpoint", translation: "selectItem_atTheCurrentPoint" },
	{ type: "fresh", translation: "selectItem_inTheLastMessage" },
];

// список доступных сервисов робота
export const ROBOT_SERVICE_TYPE_LIST: { type: ServiceTypeRobot; translation: string }[] = [
	{ type: "smc", translation: "selectItem_class" },
	{ type: "see", translation: "selectItem_entity" },
];

// список сервисов моделей робота
export const ROBOT_MODEL_SERVICE_TYPE_LIST: { type: ServiceTypeModelRobot; translation: string }[] = [
	{ type: "smc", translation: "selectItem_classifier" },
	{ type: "see", translation: "selectItem_entitySearch" },
	{ type: "tts", translation: "selectItem_synthesis" },
];

// список опций коррекции
export const CORRECTION_OPTIONS_LIST: { option: CorrectionType; translation: string }[] = [
	{ option: 0, translation: "selectItem_absent" },
	{ option: 1, translation: "selectItem_basic" },
	{ option: 2, translation: "selectItem_extended" },
	{ option: 3, translation: "selectItem_aggressive" },
];

// список событий ЭД
export const DATA_ELEM_EVENT_LIST: { event: DataElemActionEventType; translation: string }[] = [
	{ event: "alone", translation: "selectItem_ifOnlyCurrentOneIsFound" },
	{ event: "nearest", translation: "selectItem_missingElement" },
	{ event: "silence", translation: "selectItem_silence" },
	{ event: "no data", translation: "selectItem_noData" },
	{ event: "recieved", translation: "selectItem_elementRecived" },
];

// список типов условий запуска действий
export const CONDITION_RUN_ACTION_TYPE_LIST: { type: ConditionType; translation: string }[] = [
	{ type: "interval", translation: "selectItem_interval" },
	{ type: "variable", translation: "selectItem_variable" },
	{ type: "data", translation: "selectItem_data" },
	{ type: "confirmation", translation: "selectItem_confirmation" },
	{ type: "event", translation: "selectItem_event" },
];

export const CONDITION_CONFIRMATION_LIST_VARIANTS: { value: "yes" | "no"; translation: string }[] = [
	{ value: "yes", translation: "title_confirmation" },
	{ value: "no", translation: "title_noConfirmation" },
];

// список операций условий
// Для будущего обновления учловий запуска
// { operation: "=", translation: "selectItem_=" },
// { operation: "!=", translation: "selectItem_!=" },
// { operation: ">", translation: "selectItem_>" },
// { operation: ">=", translation: "selectItem_>=" },
// { operation: "<", translation: "selectItem_<" },
// { operation: "<=", translation: "selectItem_<=" },
export const OPERATION_CONDITIONS_LIST: { operation: OperationType; translation: string }[] = [
	{ operation: "=", translation: "=" },
	{ operation: "!=", translation: "!=" },
	{ operation: ">", translation: ">" },
	{ operation: ">=", translation: ">=" },
	{ operation: "<", translation: "<" },
	{ operation: "<=", translation: "<=" },
	{ operation: "exists", translation: "selectItem_exists" },
	{ operation: "not_exists", translation: "selectItem_notExists" },
	{ operation: "len=", translation: "selectItem_lengthIsEqual" },
	{ operation: "len>", translation: "selectItem_lengthIsLonger" },
	{ operation: "len<", translation: "selectItem_lengthIsLess" },
];

// список дней с опорой на производственный календарь
export const DAYS_PRODUCTION_CALENDAR_LIST: { day: DaysType; translation: string }[] = [
	{ day: "all", translation: "selectItem_allDays" },
	{ day: "workdays", translation: "selectItem_workingDays" },
	{ day: "holidays", translation: "selectItem_weekends" },
];

// список дней недели
export const WEEK_DAYS_LIST: { day: number; translationFull: string; translationShort: string }[] = [
	{ day: 1, translationFull: "Понедельник", translationShort: "title_weekDayShort_mon" },
	{ day: 2, translationFull: "Вторник", translationShort: "title_weekDayShort_tue" },
	{ day: 3, translationFull: "Среда", translationShort: "title_weekDayShort_wed" },
	{ day: 4, translationFull: "Четверг", translationShort: "title_weekDayShort_thu" },
	{ day: 5, translationFull: "Пятница", translationShort: "title_weekDayShort_fri" },
	{ day: 6, translationFull: "Суббота", translationShort: "title_weekDayShort_sat" },
	{ day: 7, translationFull: "Воскресенье", translationShort: "title_weekDayShort_sun" },
];

// список месяцев
export const MONTHS_LIST: { month: number; translationFull: string; translationShort: string }[] = [
	{ month: 1, translationFull: "Январь", translationShort: "title_monthShort_jan" },
	{ month: 2, translationFull: "Февраль", translationShort: "title_monthShort_feb" },
	{ month: 3, translationFull: "Март", translationShort: "title_monthShort_mar" },
	{ month: 4, translationFull: "Апрель", translationShort: "title_monthShort_apr" },
	{ month: 5, translationFull: "Май", translationShort: "title_monthShort_may" },
	{ month: 6, translationFull: "Июнь", translationShort: "title_monthShort_june" },
	{ month: 7, translationFull: "Июль", translationShort: "title_monthShort_july" },
	{ month: 8, translationFull: "Август", translationShort: "title_monthShort_aug" },
	{ month: 9, translationFull: "Сентябрь", translationShort: "title_monthShort_sept" },
	{ month: 10, translationFull: "Октябрь", translationShort: "title_monthShort_oct" },
	{ month: 11, translationFull: "Ноябрь", translationShort: "title_monthShort_nov" },
	{ month: 12, translationFull: "Декабрь", translationShort: "title_monthShort_dec" },
];

// список типов КТ
export const ENDPOINT_TYPES_LIST: { type: EndpointType; translation: string }[] = [
	{ type: "report", translation: "selectItem_report" },
	{ type: "service", translation: "selectItem_service" },
	{ type: "transfer", translation: "selectItem_transferOfDialogue" },
	{ type: "finish", translation: "selectItem_endOfDialogue" },
];
// словарь типов КТ
export const ENDPOINT_TYPES_DICTIONARY = Object.fromEntries(ENDPOINT_TYPES_LIST.map((item) => [item.type, item.translation]));

// список типов условий входа КТ
export const ENPOINT_ENTRY_TYPES_LIST: { type: EntryType; translation: string }[] = [
	{ type: "conditions", translation: "selectItem_conditions" },
	{ type: "inactivity", translation: "selectItem_inactivity" },
	{ type: "manual", translation: "selectItem_manual" },
];

// список типов скрипта
export const SCRIPT_TYPES_LIST: { type: ScriptType; translation: string }[] = [
	{ type: "endpoint", translation: "selectItem_endpoints" },
	{ type: "data", translation: "selectItem_dataElements" },
	{ type: "start", translation: "selectItem_startOfDialogue" },
	{ type: "beforeask", translation: "selectItem_beforeEachQuestion" },
	{ type: "afterask", translation: "selectItem_afterEachAnswer" },
	{ type: "transfer", translation: "selectItem_transferOfDialogue" },
	{ type: "hangup", translation: "selectItem_endOfDialogue" },
];

// список типов коннектора freeswitch
export const FREESWITCH_CONNECTOR_TYPES_LIST: { type: TSubtypeFreeswitsh; translation: string }[] = [
	{ type: "robot", translation: "selectItem_asRobot" },
	{ type: "assistant", translation: "selectItem_asAssistant" },
];

// список типов коннектора web
export const WEB_CONNECTOR_TYPES_LIST: { type: TTypeWeb; translation: string }[] = [
	{ type: "chat", translation: "selectItem_chat" },
	{ type: "assistant", translation: "selectItem_assistant" },
];

// расширенные списки //
// export const ACTION_EXTENDED_LIST: { action: ActionExtended; translation: string }[] = [
// 	{ action: "chooseAction", translation: "selectItem_selectAction" },
// 	...ACTION_LIST,
// ];

export const ACTION_TYPE_EXTENDED_LIST: { actionType: ActionTypeExtended; translation: string }[] = [
	{ actionType: "chooseActionType", translation: "selectItem_selectType" },
	...ACTION_TYPE_LIST,
];

export const SERVICE_TYPE_EXTENDED_LIST: { serviceType: ServiceTypeExtended; translation: string }[] = [
	{ serviceType: "chooseService", translation: "selectItem_selectService" },
	...SERVICE_TYPE_LIST,
];

export const DATA_ELEM_TYPE_EXTENDED_LIST: { type: DataElemTypeExtended; translation: string }[] = [
	{ type: "all", translation: "selectItem_all" },
	...DATA_ELEM_TYPE_LIST,
];

export const ROBOT_SERVICE_TYPE_EXTENDED_LIST: { type: ServiceTypeRobotExtended; translation: string }[] = [
	{ type: "chooseType", translation: "selectItem_selectType" },
	...ROBOT_SERVICE_TYPE_LIST,
];

export const ROBOT_MODEL_SERVICE_TYPE_EXTENDED_LIST: { type: ServiceTypeModelRobotExtended; translation: string }[] = [
	{ type: "chooseType", translation: "selectItem_selectType" },
	...ROBOT_MODEL_SERVICE_TYPE_LIST,
];

export const CONDITION_RUN_ACTION_TYPE_EXTENDED_LIST: { type: ConditionTypeExtended; translation: string }[] = [
	{ type: "chooseType", translation: "selectItem_selectType" },
	...CONDITION_RUN_ACTION_TYPE_LIST,
];
